/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';
import ReactDOM from 'react-dom';
import { RouterProvider } from 'react-router';

import { ExternalAppProviders } from 'shared-ui/external-app-base';
import { useRum } from 'shared-ui/utils/rum';

import { router } from './router';

export default function App() {
    useRum();

    return (
        <ExternalAppProviders>
            <RouterProvider router={router} />
        </ExternalAppProviders>
    );
}
